import { useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  GATEWAY_API_LOGOUT,
  API_AUTH_COOKIE_NAME,
  LOGOUT_JJ_URI,
  LOGOUT_MT_URI,
  LOGOUT_IM_URI
} from '../../../util/config'
import { gatewayRequestAxios } from '../../../api/interceptor'

export function useLogoutLogic() {
  const navigate = useNavigate()

  const clearStorageExceptFeedbackMute = useCallback(() => {
    const feedbackMuteUntil = localStorage.getItem('feedbackMuteUntil')
    localStorage.clear()
    if (feedbackMuteUntil) {
      localStorage.setItem('feedbackMuteUntil', feedbackMuteUntil)
    }
    sessionStorage.removeItem('logoutWarning')
  }, [])

  const clearAuthCookie = useCallback(() => {
    document.cookie = `${API_AUTH_COOKIE_NAME}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`
  }, [])

  const setIntentionalLogout = useCallback(() => {
    sessionStorage.setItem('intentionalLogout', 'true')
  }, [])

  const navigateToLogin = useCallback((branding) => {
    let logoutUrl
    if (branding === 'IM') {
      logoutUrl = LOGOUT_IM_URI
    } else if (branding === 'MT' || branding === 'JM') {
      logoutUrl = LOGOUT_MT_URI
    } else {
      logoutUrl = LOGOUT_JJ_URI
    }

    window.location.href = logoutUrl
  }, [navigate])

  const performLogout = useCallback(async () => {
    const branding = localStorage.getItem('branding')
    await gatewayRequestAxios.get(GATEWAY_API_LOGOUT, {})
    clearStorageExceptFeedbackMute()
    clearAuthCookie()
    setIntentionalLogout()
    navigateToLogin(branding)
  }, [clearStorageExceptFeedbackMute, clearAuthCookie, setIntentionalLogout, navigateToLogin])

  useEffect(() => {
    performLogout()
  }, [performLogout])

  return {
    performLogout,
    clearStorageExceptFeedbackMute,
    clearAuthCookie,
    setIntentionalLogout,
    navigateToLogin
  }
}
